(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-card__quick-view-btn');
    if (btn) {
      openQuickView(btn.dataset.quickViewUrl);
    }
    if (e.target.id === 'qv-modal-overlay') {
      closeQuickView();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeQuickView();
  });

  function openQuickView(url) {
    var overlay = document.getElementById('qv-modal-overlay');
    var content = document.getElementById('qv-modal-content');
    if (!overlay || !content) return;

    content.innerHTML = '<p style="padding:40px;">Loading...</p>';
    overlay.classList.add('is-open');

    fetch(url + '.js')
      .then(function (res) { return res.json(); })
      .then(renderProduct)
      .catch(function () {
        content.innerHTML = '<p style="padding:40px;">Something went wrong.</p>';
      });
  }

  function closeQuickView() {
    var overlay = document.getElementById('qv-modal-overlay');
    if (overlay) overlay.classList.remove('is-open');
  }

  function renderProduct(product) {
    var content = document.getElementById('qv-modal-content');
    var variant = product.variants[0];

    content.innerHTML =
      '<div style="display:grid;grid-template-columns:1fr 1fr;">' +
        '<img src="' + (product.featured_image || '') + '" style="width:100%;height:100%;object-fit:cover;" alt="">' +
        '<div style="padding:32px;">' +
          '<h2 style="margin:0 0 12px;">' + product.title + '</h2>' +
          '<p style="font-weight:700;margin-bottom:20px;">' + formatMoney(variant.price) + '</p>' +
          '<button type="button" id="qv-add-to-cart" data-variant-id="' + variant.id + '" style="padding:14px 28px;background:#000;color:#fff;border:none;border-radius:4px;cursor:pointer;">Add to Cart</button>' +
        '</div>' +
      '</div>';
  }

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  document.addEventListener('click', function (e) {
    if (e.target.id === 'qv-add-to-cart') {
      var variantId = e.target.dataset.variantId;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(function () {
        closeQuickView();
      });
    }
  });
})();